const extractor = data => {
    const list_data = data.split('<img src="');
    const splitted = list_data.map(_i => _i.split('" style')[0]);
    return splitted.filter(img => img.includes('data:')).map(img => img.slice(0, img.indexOf('"')));
};

export default extractor;
